import Pagination from "@mui/material/Pagination";
import TablePagination from "@mui/material/TablePagination";
import "./Pagination.css";

interface Props {
  className?: string;
  page?: number;
  setPage?: (value: number) => void;
  pageSize?: number;
  setPageSize?: (value: number) => void;
  totalFiltered?: number;
}

const CustomPagination = (props: Props) => {
  const {
    page = 0,
    setPage,
    pageSize = 10,
    setPageSize,
    totalFiltered = 0,
  } = props;

  const handleChangePage = (e: any, newPage: number) => {
    setPage && setPage(newPage - 1);
  };

  const handleChangeOffset = (e: any, newPage: number) => {
    setPage && setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPageSize && setPageSize(parseInt(event.target.value, 10));
    setPage && setPage(0);
  };

  const totalPages = Math.ceil(totalFiltered / pageSize);

  return (
    <div className="pagination-container">
      
      {/* Left – rows per page */}
      <div className="pagination-left">
        <TablePagination
          component="div"
          rowsPerPageOptions={[10, 20, 50, 100]}
          rowsPerPage={pageSize}
          count={totalFiltered}
          page={page}
          onPageChange={handleChangeOffset}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Rows"
        />
      </div>

      {/* Center – page numbers */}
      <div className="pagination-center">
        <Pagination
          variant="outlined"
          shape="rounded"
          color="primary"
          count={totalPages}
          page={page + 1}
          onChange={handleChangePage}
        />
      </div>

      {/* Right – total */}
      <div className="pagination-right">
        Total: {totalFiltered}
      </div>

    </div>
  );
};

export default CustomPagination;
